import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.95.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/ui/Avatar/Avatar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/(main)/[locale]/(pages)/about-me/page.module.scss");
